// extracted by mini-css-extract-plugin
export default {"outerDiv":"verticals-page_outerDiv__xQgqG","addBtn":"verticals-page_addBtn__WKgBj"};